export const backgroundCheckingStatus: {
  label: string;
  btnClass: string;
  class: string;
}[] = [
  {
    label: 'Process initiated',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-hourglass'
  },
  {
    label: 'In progress',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-hourglass v-text-warning'
  },
  {
    label: 'Completed',
    btnClass: 'v-btn-success',
    class: 'lnr lnr-check v-text-success'
  },
  {
    label: 'Completed (Clear)',
    btnClass: 'v-btn-success',
    class: 'lnr lnr-check v-text-success'
  },
  {
    label: 'Completed (Not Clear)',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-cross v-text-danger'
  },
  {
    label: 'Invitation sent',
    btnClass: 'v-btn-info',
    class: 'lnr lnr-envelope v-text-info'
  },
  {
    label: 'Invitation accepted',
    btnClass: 'v-btn-info',
    class: 'lnr lnr-checkmark-circle v-text-info'
  },
  {
    label: 'Application begun',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-pencil v-text-warning'
  },
  {
    label: 'Application completed',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-file-add v-text-warning'
  },
  {
    label: 'Screening begun',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-magnifier v-text-warning'
  },
  // Mintz steps between the invite and the check itself. Showing them keeps a
  // recruiter from re-requesting a check that is already moving (each request
  // opens, and bills, a new case at the vendor).
  {
    label: 'Candidate submitted',
    btnClass: 'v-btn-info',
    class: 'lnr lnr-user v-text-info'
  },
  {
    label: 'On hold (information needed)',
    btnClass: 'v-btn-warning',
    class: 'lnr lnr-warning v-text-warning'
  },
  {
    label: 'Cancelled',
    btnClass: 'v-btn-light',
    class: 'lnr lnr-cross v-text-muted'
  }
];

export enum Providers {
  Mintz = 'mintz',
  ValidityScreening = 'validity_screening'
}
